module.exports = __webpack_public_path__ + "img/pg2-article3-bg.f3dba829.png";